import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  livePlayerData: {},
  isLoggedIn: false
};

export const liveWebinarReducer = createReducer(initialState, {
  [types.LIVE_WEBINAR_LIST_RESPONSE](state, action) {
    return {
      ...state,
      timestamp: action.response.timestamp,
      data: action.response.data,
      errorMessage: action.response.message
    };
  },
  [types.LIVE_WEBINAR_PLAYER_RESPONSE](state, action) {
    return {
      ...state,
      livePlayerData: action.response.data,
      errorMessage: action.response.message
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState
    };
  }
});
